/*
 * @Author: LiuMeiYu
 * @Date: 2023-01-12 15:53:20
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-06-02 11:39:36
 * @FilePath: \nivara\src\api\index.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import $http from "../http/index"
import qs from "qs"
import md5 from "js-md5";

const appid = "web-cardswap-v1";
const device_no = localStorage.getItem("device_no") || "123456";
const appkey = "9c75d6d07da5ae994455a173b28435e5";
const token = localStorage.getItem("token");
const app_version = 170;


// 获取国家列表
export const getCountryListApi = (data) => {
  return $http({
    url: "/gc/public/countrylist",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 获取国家区号
export const getCountryCodeApi = (data) => {
  return $http({
    url: "/gc/public/countryCode",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 登录
export const userLoginApi = (data) => {
  return $http({
    url: "/gc/user/applogin",
    method: "post",
    data: qs.stringify({
      appid,
      device_no,
      sign: md5(qs.stringify({
        appid,
        device_no,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 注册
export const userRegisterApi = (data) => {
  return $http({
    url: "/gc/user/appregister",
    method: "post",
    data: qs.stringify({
      appid,
      device_no,
      channel_type: 3,
      sign: md5(qs.stringify({
        appid,
        device_no,
        channel_type: 3,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户注册发送邮箱验证码
export const getEmailVerificationCodeApi = (data) => {
  return $http({
    url: "/gc/user/sendappregistercode",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户绑定邮箱发送邮件验证码
export const sendEmailBindVerifyCodeApi = (data) => {
  return $http({
    url: "/gc/user/sendemailbindverifycode",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 查询账户密保状态与信息
export const getUserSecurityInfoApi = (data) => {
  return $http({
    url: "/gc/user/getusersecurityinfo",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户注册发送WhatsApp验证码
export const getWhatsAppVerificationCodeApi = (data) => {
  return $http({
    url: "/gc/user/sendWhatsAppCode",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户通过手机号码修改密码
export const updatePasswordByWhatappApi = (data) => {
  return $http({
    url: "/gc/user/updatepasswordbywhatsapp",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户通过邮箱修改密码
export const updatePasswordByEmailApi = (data) => {
  return $http({
    url: "/gc/user/updatepasswordbyemail",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 修改用户名
export const updateUsernameApi = (data) => {
  return $http({
    url: "/gc/user/updateUsername",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 修改昵称
export const updateNicknameApi = (data) => {
  return $http({
    url: "/gc/user/modinickname",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户修改头像
export const updateAvatarApi = (data) => {
  return $http({
    url: "/gc/account/avatar",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户基本信息
export const getUserInfoApi = (data) => {
  return $http({
    url: "/gc/user/userinfo",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户钱包详情
export const getUserBalanceApi = (data) => {
  return $http({
    url: "/gc/wallet/balance",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 获取订单列表
export const getOrderListApi = (data) => {
  return $http({
    url: "/gc/order/orderList",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 获取需求列表
export const getDemandListApi = (data) => {
  return $http({
    url: "/gc/card/demand",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 获取评论列表
export const getOrderCommentListApi = (data) => {
  return $http({
    url: "/gc/order/commentlist",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 需求用户信息
export const getDemandUserInfoApi = (data) => {
  return $http({
    url: "/gc/user/demanduserinfo",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户提交订单
export const userSubmitOrderApi = (data) => {
  return $http({
    url: "/gc/order/orderadd",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        channel_type: 3,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      channel_type: 3,
      ...data
    })
  })
}
// 获取用户银行卡列表
export const getUserBankListApi = (data) => {
  return $http({
    url: "/gc/userbank/list",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 根据银行卡种类和卡号获取开户名
export const getBankNameApi = (data) => {
  return $http({
    url: "/gc/userbank/verifyinfo",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 添加银行卡
export const addUserBindBankApi = (data) => {
  return $http({
    url: "/gc/userbank/add",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 删除银行卡
export const deleteUserBindBankApi = (data) => {
  return $http({
    url: "/gc/userbank/delete",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 设置默认银行卡
export const setUserDefaultBindBankApi = (data) => {
  return $http({
    url: "/gc/userbank/setdef",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 获取银行种类列表
export const getBankCategoryListApi = (data) => {
  return $http({
    url: "/gc/userbank/categorylist",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 获取用户提现信息
export const getUserWithdrawInfoApi = (data) => {
  return $http({
    url: "/gc/withdraw/information",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 用户申请提现
export const userApplyWithdrawApi = (data) => {
  return $http({
    url: "/gc/withdraw/apply",
    method: "post",
    data: qs.stringify({
      appid,
      device_no,
      app_version,
      token,
      channel_type: 3,
      sign: md5(qs.stringify({
        appid,
        device_no,
        app_version,
        token,
        channel_type: 3,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户设置提现密码
export const setWithdrawPasswordApi = (data) => {
  return $http({
    url: "/gc/withdraw/transactionPassword",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 用户修改交易密码
export const updateWithdrawUpTPasswordApi = (data) => {
  return $http({
    url: "/gc/withdraw/upTPassword",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 用户修改登录密码
export const updateLoginPasswordApi = (data) => {
  return $http({
    url: "/gc/user/modipassword",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户绑定邮箱发送验证码
export const sendBindEmailVerifyCodeApi = (data) => {
  return $http({
    url: "/gc/user/sendemailbindverifycode",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户绑定邮箱
export const userBindEmailApi = (data) => {
  return $http({
    url: "/gc/user/bindemail",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户绑定手机
export const userBindPhoneApi = (data) => {
  return $http({
    url: "/gc/user/bindWhatsapp",
    method: "post",
    data: qs.stringify({
      appid,
      token,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}
// 用户钱包明细列表
export const getUserWalletLogApi = (data) => {
  return $http({
    url: "/gc/wallet/moneyloglist",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        token,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      token,
      ...data
    })
  })
}
// 用户钱包明细列表
export const getUserWalletLogDetailApi = (data) => {
  return $http({
    url: "/gc/wallet/moneylogdetail",
    method: "post",
    data: qs.stringify({
      appid,
      sign: md5(qs.stringify({
        appid,
        ...data
      }, { arrayFormat: 'indices', encode: false }) + appkey),
      ...data
    })
  })
}